import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import { useTranslation } from 'react-i18next';

function NoRatings() {
  const { t } = useTranslation('static_pages');

  return (
    <Box display="inline-flex">
      <Typography variant="body2" sm={{ textAlign: 'center' }} fontSize={14}>
        {t('catererCards.noReviewsYet')}
      </Typography>
    </Box>
  );
}

const HIGHEST_SCORE = 5;

function Rating({ score = 0, isRated }) {
  const { i18n } = useTranslation();

  const formatNumberForLocale = (number) =>
    number.toLocaleString(i18n.languages[0], {
      minimumFractionDigits: 1,
    });

  const normalizedScore = React.useMemo(() => score / 10, [score]);
  const filledStarsArray = React.useMemo(
    () => Array.from({ length: Math.floor(normalizedScore) }),
    [normalizedScore]
  );
  const emptyStarsArray = React.useMemo(
    () => Array.from({ length: Math.floor(HIGHEST_SCORE - normalizedScore) }),
    [normalizedScore]
  );

  if (!isRated) return <NoRatings />;

  return (
    <Box display="flex" lineHeight={0} minWidth="147px">
      <Box marginRight={1} display="flex" alignItems="center">
        <Typography variant="body1" fontSize={14}>
          {formatNumberForLocale(normalizedScore)}
        </Typography>
      </Box>
      <Box>
        {filledStarsArray.map((_, index) => (
          <StarIcon color="secondary" key={index} fontSize="small" />
        ))}
        {normalizedScore % 1 !== 0 && (
          <StarHalfIcon color="secondary" fontSize="small" />
        )}
        {emptyStarsArray.map((_, index) => (
          <StarBorderIcon color="secondary" key={index} fontSize="small" />
        ))}
      </Box>
    </Box>
  );
}

export default Rating;
